export default __webpack_public_path__ + "atomic/_patterns/03-organisms/link-to-affiliate-block/_link-to-affiliate-block.twig";